import { render, staticRenderFns } from "./InternetDiscountPopinShared.vue?vue&type=template&id=77d87339&scoped=true"
import script from "./InternetDiscountPopinShared.vue?vue&type=script&lang=ts"
export * from "./InternetDiscountPopinShared.vue?vue&type=script&lang=ts"
import style0 from "./InternetDiscountPopinShared.vue?vue&type=style&index=0&id=77d87339&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d87339",
  null
  
)

export default component.exports